import {eatalianoAxios} from "@/data/api/http/axios";
import {
    PlacedOrderOverview,
    PosOrderCancellation,
    PosOrderEdit,
    PosOrderPlacement,
    PosOrderPrint,
    PosOrderSummary,
    PosOrderUpdate
} from "@/data/entities/order";

export const listOrders = (restaurantId: number, date?: string): Promise<PosOrderSummary[]> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/pos/orders`, {params: {date}})
        .then(response => response.data)
);

export const getOrder = (restaurantId: number, publicCartId: string): Promise<PlacedOrderOverview> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/pos/orders/${publicCartId}`)
        .then(response => response.data)
);

export const placeOrder = (restaurantId: number, order: PosOrderPlacement): Promise<PlacedOrderOverview> => (
    eatalianoAxios
        .post(`/restaurant/${restaurantId}/pos/orders`, order)
        .then(response => response.data)
);

export const updateOrder = (
    restaurantId: number,
    publicCartId: string,
    order: PosOrderUpdate,
): Promise<PlacedOrderOverview> => (
    eatalianoAxios
        .put(`/restaurant/${restaurantId}/pos/orders/${publicCartId}`, order)
        .then(response => response.data)
);

export const getOrderForEdit = (restaurantId: number, publicCartId: string): Promise<PosOrderEdit> => (
    eatalianoAxios
        .get(`/restaurant/${restaurantId}/pos/orders/${publicCartId}/edit`)
        .then(response => response.data)
);

export const printOrder = (restaurantId: number, publicCartId: string, print: PosOrderPrint): Promise<void> => (
    eatalianoAxios
        .post(`/restaurant/${restaurantId}/pos/orders/${publicCartId}/print`, print)
        .then(() => undefined)
);

export const cancelOrder = (
    restaurantId: number,
    publicCartId: string,
    cancellation: PosOrderCancellation,
): Promise<PlacedOrderOverview> => (
    eatalianoAxios
        .post<PlacedOrderOverview>(`/restaurant/${restaurantId}/pos/orders/${publicCartId}/cancel`, cancellation)
        .then(res => res.data)
);
